import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
    Alert
} from '@mui/material';
import { useUser } from '../../context/UserContext';
import { useSigilContext } from '../../context/sigilContext';

const NameSelectionModal = ({ open }) => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { registerUser } = useUser();
    const { i18n } = useSigilContext();
    const translate = i18n?.forum?.nameModal || {};

    const handleSubmit = async () => {
        if (!name.trim()) return;

        setIsSubmitting(true);
        setError('');

        try {
            await registerUser(name.trim());
            // Modal will close automatically because 'open' is controlled by 'user' state in parent
        } catch (err) {
            setError(err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            fullWidth
            maxWidth="xs"
            PaperProps={{
                sx: {
                    backgroundColor: '#2C2C2C',
                    color: '#FFFFFF',
                    border: '1px solid #FFFFFF',
                    borderRadius: '18px'
                }
            }}
        >
            <DialogTitle>{translate.title || 'Bienvenido al Foro'}</DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    {translate.description || 'Para participar, por favor elige un nombre de usuario. Este nombre se guardará en este dispositivo.'}
                </Typography>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    placeholder={translate.placeholder || 'Ej. MagoDelCaos'}
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    error={!!error}
                    helperText={error}
                    disabled={isSubmitting}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            color: 'white',
                            '& fieldset': {
                                borderColor: 'white',
                            },
                            '&:hover fieldset': {
                                borderColor: 'white',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'white',
                            },
                        },
                        '& .MuiInputLabel-root': {
                            color: 'rgba(255, 255, 255, 0.7)',
                            '&.Mui-focused': {
                                color: 'white',
                            },
                        },
                        '& .MuiFormHelperText-root': {
                            color: '#FFD179'
                        }
                    }}
                />
                {error && (
                    <Alert severity="error" sx={{ marginTop: 2 }}>
                        {error}
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={!name.trim() || isSubmitting}
                >
                    {isSubmitting ? (translate.saving || 'Guardando...') : (translate.continueButton || 'Continuar')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NameSelectionModal;
